export const ICON_SUBMENU = 'circle-chevron-right';

/**
 * You can attach authorization to a menu item to control access  (both in parent and children).
 *
 * authorization: 'dashboard.view'
 * authorization: ['invoices.create', 'invoices.update', 'role:Admin', 'role:Finance']
 *
 * If any of the permissions or roles match, the menu item will be shown.
 *
 * The `icon` use icon name from Font Awesome 6.7.2 (https://fontawesome.com/v6/search)
 * It is only used in the following components:
 * - Navigation Drawer
 * - AppBar Avatar
 * - InvoiceView
 *
 * Please register the icons you used as explained in `/docs/Customization.md`
 *
 * Other components use Material Design Icons (https://pictogrammers.github.io/@mdi/font/7.4.47/)
 */

const navDrawerMenuItems = [
  {
    id: 'menuHome',
    title: 'HOME',
    icon: 'house',
    iconType: 'solid',
    to: '/home',
  },
  {
    id: 'menuDashboard',
    title: 'DASHBOARD',
    icon: 'gauge-high',
    to: '/dashboard',
    authorization: 'dashboard.view',
  },
  { divider: true },
  { header: 'APPLICATIONS' },
  {
    id: 'menuCompany',
    title: 'Company',
    icon: 'sitemap',
    to: '/companies',
    authorization: 'companies.view',
  },
  {
    id: 'menuCustomer',
    title: 'Customer',
    icon: 'address-book',
    to: '/customers',
    authorization: 'customers.view',
  },
  {
    id: 'menuProduct',
    title: 'Product',
    icon: 'box-open',
    to: '/products',
    authorization: 'products.view',
  },
  {
    id: 'menuTaxGroup',
    title: 'Tax & Tax Type',
    icon: 'percent',
    children: [
      {
        id: 'menuTax',
        title: 'Tax',
        icon: ICON_SUBMENU,
        to: '/taxes',
        authorization: 'taxes.view',
      },
      {
        id: 'menuTaxType',
        title: 'Tax Type',
        icon: ICON_SUBMENU,
        to: '/tax-types',
        authorization: 'tax-types.view',
      },
    ],
  },
  {
    id: 'menuInvoice',
    title: 'Invoice',
    icon: 'file-invoice',
    to: '/invoices',
    authorization: 'invoices.view',
  },
  {
    id: 'menuReminder',
    title: 'Invoice Reminder',
    icon: 'bell',
    to: '/invoice-reminders',
    authorization: 'invoice-reminders.view',
  },
  {
    id: 'menuReceipt',
    title: 'Receipt',
    icon: 'hand-holding-dollar',
    to: '/receipts',
    authorization: 'receipts.view',
  },
  { divider: true },
  { header: 'SYSTEM' },
  {
    id: 'menuUserRole',
    title: 'User & Role',
    icon: 'users',
    children: [
      {
        id: 'menuUser',
        title: 'User',
        icon: ICON_SUBMENU,
        to: '/users',
        authorization: 'users.view',
      },
      {
        id: 'menuRole',
        title: 'Role',
        icon: ICON_SUBMENU,
        to: '/roles',
        authorization: 'roles.view',
      },
    ],
  },
];

export default navDrawerMenuItems;
